(function (root, factory) {
  const make = factory();
  if (typeof module === 'object' && module.exports) module.exports = make;
  else {
    const element = root.document.getElementById('optimus-affiliation-config');
    if (element) { try { make(root, JSON.parse(element.textContent)).start(); } catch {} }
  }
})(typeof window === 'undefined' ? null : window, function () {
  return function (win, config) {
    const COOKIE = '__Host-op_affiliation';
    const TOKEN_KEY = '__optimus_affiliation_token';
    const CONSENT_KEY = '__optimus_affiliation_consent';
    let pending = null, current = null, epoch = 0, consentReady = false, work = Promise.resolve(), initialized = false, diagnosticMode = false;
    function diagnostic(message) {
      if (!diagnosticMode) return;
      const doc = win.document;
      let badge = doc.getElementById('optimus-affiliation-selftest-result');
      if (!badge) {
        badge = doc.createElement('output');
        badge.id = 'optimus-affiliation-selftest-result';
        badge.setAttribute('role','status'); badge.setAttribute('aria-live','polite');
        badge.style.cssText = 'position:fixed;z-index:2147483647;bottom:12px;left:12px;max-width:calc(100vw - 24px);padding:12px 16px;background:#111827;color:#fff;font:14px/1.4 monospace;border-radius:8px;box-shadow:0 2px 12px #0006';
        (doc.body || doc.documentElement).appendChild(badge);
      }
      badge.textContent = 'Optimus SELFTEST · ' + message;
    }
    function privacy() { return win.Shopify?.customerPrivacy; }
    function permitted() {
      try { return consentReady && privacy().currentVisitorConsent().marketing === 'yes' && privacy().marketingAllowed() === true; }
      catch { return false; }
    }
    function live(record) {
      if (!record || !/^[a-f0-9]{64}$/.test(record.token || '')) return false;
      const at = Date.parse(record.clicked_at), end = Date.parse(record.expires_at);
      return Number.isFinite(at) && end === at + 30*86400000 && win.Date.now() >= at && win.Date.now() < end;
    }
    function read() {
      if (!permitted()) return null;
      const value = win.document.cookie.split('; ').find(v=>v.startsWith(COOKIE+'='));
      if (!value) return null;
      try { const record = JSON.parse(decodeURIComponent(value.slice(COOKIE.length+1))); return live(record) ? record : null; } catch { return null; }
    }
    function erase() { win.document.cookie = COOKIE+'=; Max-Age=0; Path=/; Secure; SameSite=Lax'; }
    function save(record) {
      if (!permitted() || !live(record)) return;
      const seconds = Math.floor((Date.parse(record.expires_at)-win.Date.now())/1000);
      win.document.cookie = COOKIE+'='+encodeURIComponent(JSON.stringify(record))+'; Max-Age='+seconds+'; Path=/; Secure; SameSite=Lax';
    }
    async function post(body) {
      let response;
      try {
        response = await win.fetch(config.endpoint,{method:'POST',credentials:'omit',referrerPolicy:'no-referrer',
          headers:{'Content-Type':'application/json'},body:JSON.stringify(body),signal:win.AbortSignal.timeout(5000)});
      } catch (error) {
        if (body.action === 'click' && body.code === 'SELFTEST') diagnostic('NETWORK_ERROR');
        throw error;
      }
      let data = {};
      try { data = await response.clone().json(); } catch {}
      if (!response.ok) {
        if (body.action === 'click' && body.code === 'SELFTEST') {
          const code = /^[A-Z0-9_]+$/.test(data?.code || '') ? data.code : 'ERROR';
          diagnostic('HTTP_' + response.status + '_' + code);
        }
        throw Error('COLLECTEUR_HTTP_' + response.status);
      }
      if (body.action === 'click' && body.code === 'SELFTEST') {
        const code = data?.tracked === true ? 'TRACKED' : (/^[A-Z0-9_]+$/.test(data?.code || '') ? data.code : 'NOT_TRACKED');
        diagnostic('RELAY_' + code);
      }
      return response.json();
    }
    async function cart(record, allowed) {
      const response = await win.fetch(win.Shopify.routes.root+'cart/update.js',{method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{[TOKEN_KEY]:record?.token || '',[CONSENT_KEY]:allowed?'yes':'no'}}),
        signal:win.AbortSignal.timeout(5000)});
      if (!response.ok) throw Error('PANIER_NON_RACCORDE');
    }
    async function reconcile() {
      const version = epoch;
      if (!permitted()) {
        const previous = current; current = null; erase();
        await cart(null,false);
        if (previous?.token) { try { await post({action:'revoke',token:previous.token}); } catch {} }
        return;
      }
      current = read();
      const code = pending;
      if (code) {
        const consent_id = privacy().consentId?.();
        if (typeof consent_id === 'string' && consent_id) {
          pending = null;
          let result;
          try { result = await post({action:'click',code,marketing_consent:'yes',marketing_allowed:true,consent_id}); } catch {}
          if (version !== epoch || !permitted()) {
            if (result?.token) { try { await post({action:'revoke',token:result.token}); } catch {} }
            return;
          }
          if (result?.tracked === true && live(result)) {
            const newer = read();
            if (!newer || Date.parse(result.clicked_at) >= Date.parse(newer.clicked_at)) {
              current = {token:result.token,clicked_at:result.clicked_at,expires_at:result.expires_at}; save(current);
            } else current = newer;
          }
        }
      }
      if (version !== epoch || !permitted()) return;
      current = read();
      await cart(current,!!current);
    }
    function enqueue() { work = work.catch(()=>{}).then(reconcile); return work; }
    function consentChanged() { epoch++; if (!permitted()) pending = null; return enqueue(); }
    function setup() {
      if (initialized) return; initialized = true; consentReady = true;
      const values = new win.URL(win.location.href).searchParams.getAll('op_aff');
      if (values.length === 1 && /^[A-Z0-9][A-Z0-9-]{0,31}$/.test(values[0])) pending = values[0];
      if (values.length) {
        const url = new win.URL(win.location.href); url.searchParams.delete('op_aff');
        win.history.replaceState(win.history.state,'',url.pathname+url.search+url.hash);
      }
      win.document.addEventListener('visitorConsentCollected',consentChanged);
      win.addEventListener('pageshow',()=>{ if (permitted()) enqueue(); });
      win.document.addEventListener('visibilitychange',()=>{ if (win.document.visibilityState==='visible' && permitted()) enqueue(); });
      if (permitted()) { diagnostic('CONSENT_GRANTED'); enqueue(); }
      else {
        let consent = 'UNKNOWN';
        try { consent = String(privacy().currentVisitorConsent().marketing || 'UNKNOWN').toUpperCase(); } catch {}
        diagnostic('CONSENT_' + consent);
        if (consent === 'NO') enqueue();
      }
    }
    function privacyReady() {
      const api = privacy();
      return !!api && typeof api.currentVisitorConsent === 'function' &&
        typeof api.marketingAllowed === 'function' && typeof api.consentId === 'function';
    }
    function start() {
      const selftestLink = new win.URL(win.location.href).searchParams.getAll('op_aff').includes('SELFTEST');
      diagnosticMode = selftestLink && String(config?.endpoint || '').includes('optimus-affiliation-click-relay-test');
      if (diagnosticMode) diagnostic('SCRIPT_STARTED');
      if (config?.enabled !== true) { diagnostic('CONFIG_DISABLED'); return; }
      if (!/^https:\/\//.test(config.endpoint || '') || win.location.protocol !== 'https:') { diagnostic('CONFIG_INVALID'); return; }
      if (privacyReady()) { setup(); return; }
      let loaderChecks = 0, loadAttempts = 0;
      const loadPrivacyApi = () => {
        if (privacyReady()) { setup(); return; }
        const loadFeatures = win.Shopify?.loadFeatures;
        if (typeof loadFeatures !== 'function') {
          if (loaderChecks++ < 30) { win.setTimeout(loadPrivacyApi,100); return; }
          win.console?.warn?.('[Optimus Affiliation] Customer Privacy API unavailable'); diagnostic('PRIVACY_API_UNAVAILABLE');
          return;
        }
        try {
          loadFeatures.call(win.Shopify,[{name:'consent-tracking-api',version:'0.2'}],error=>{
            if (error) {
              if (loadAttempts++ < 1) { win.setTimeout(loadPrivacyApi,250); return; }
              win.console?.warn?.('[Optimus Affiliation] Customer Privacy API failed to load'); diagnostic('PRIVACY_API_LOAD_FAILED');
              return;
            }
            if (!privacyReady()) {
              if (loadAttempts++ < 1) { win.setTimeout(loadPrivacyApi,250); return; }
              win.console?.warn?.('[Optimus Affiliation] Customer Privacy API is incomplete'); diagnostic('PRIVACY_API_INCOMPLETE');
              return;
            }
            setup();
          });
        } catch {
          if (loadAttempts++ < 1) { win.setTimeout(loadPrivacyApi,250); return; }
          win.console?.warn?.('[Optimus Affiliation] Customer Privacy API failed to initialize'); diagnostic('PRIVACY_API_INIT_FAILED');
        }
      };
      loadPrivacyApi();
    }
    return {start,consentChanged,settled:()=>work};
  };
});
